import { render, staticRenderFns } from "./RcvED.vue?vue&type=template&id=4c8d4fc7"
import script from "./RcvED.vue?vue&type=script&lang=js"
export * from "./RcvED.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports